import { BoxProps, Flex } from "@chakra-ui/react";
import * as React from "react";

export const PageCanvas = (props: BoxProps) => {
  return (
    <Flex
      as="main"
      flex={1}
      overflow="hidden"
      direction="column"
      {...props}
    ></Flex>
  );
};
